<template>
    <snoop-cookie-consent
        :config="$snoopCookieConsent.config"
        :preloaded-settings="$snoopCookieConsent.preloadedSettings"
        :locale="locale"
        @load="$emit('load', $event)"
        @update="$emit('update', $event)"
    />
</template>

<script>
import SnoopCookieConsent from './CookieConsent'


export default {
    components: { SnoopCookieConsent },

    props: {
        locale: { type: String, default: null },
    },

    mounted () {
        this.$snoopCookieConsent.ConsentState.$on('update', this.clearPreloading)
    },

    destroyed () {
        this.$snoopCookieConsent.ConsentState.$off('update', this.clearPreloading)
    },

    methods: {
        /**
         * Clear preloaded settings so that subsequent routes use the updated
         * settings by the user and not the intially parsed settings.
         *
         * Otherwise the cookie layer will open on every (nuxt) route change.
         * Because the nuxt-cookie-consent may by rendered again on a new page
         * depending on where it is mounted (layouts vs pages vs components).
         */
        clearPreloading () {
            this.$snoopCookieConsent.preloadedSettings = null
        },
    },
}
</script>
